import {
    useEffect,
    useState,
    useMemo
} from 'react';
import {
    Container,
    SelectTags,
    Content
} from './styled';
import {
    ContentGroup
} from './components/ContentGroup';
import {
    Tab,
    Tabs,
    SelectMultipleCustomerService
} from '../../../../../../components';
import { useChat } from '../../../../../../contexts/chat';

export function Group(props) {

    const { isVisibility, allowAddInRoom } = props;
    const {
        idChat,
        resetChat,
        customer,
        myChatsGroup,
        myTagsGroup,
        handleMyGroup
    } = useChat();

    const [dataCustomer, setDataCustomer] = useState({});
    const [tagSelected, setTagSelected] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState({
        isOpen: false,
        customerServicersID: []
    });

    useEffect(() => {
        if (!isVisibility) return
        if (!myChatsGroup) return
        const isChatOpen = myChatsGroup.some(item =>
            item.customer_services.some(
                service => service.client_phone === idChat
            )
        );
        if (!isChatOpen) {
            resetChat();
        }
    }, [myChatsGroup]);
    useEffect(() => {
        handleMyGroup();
    }, [])
    useEffect(() => {
        if (typeof customer !== 'string') {
            setDataCustomer(customer);
            return
        }
        setDataCustomer(JSON.parse(customer));
        return
    }, [customer]);

    const allIDS = myChatsGroup.flatMap(
        (group) => group.customer_services?.map((item) => item.id)
    );
    const onSelectedCustomer = (id) => {
        setSelectedCustomer(prev => {
            const updatedCustomerServicersID = prev.customerServicersID.includes(id)
                ? prev.customerServicersID.filter(item => item !== id)
                : [...prev.customerServicersID, id];
            return {
                ...prev,
                customerServicersID: updatedCustomerServicersID
            };
        });
    };
    const handleSelectedAll = (e) => {
        if (e) {
            setSelectedCustomer({
                isOpen: true,
                customerServicersID: allIDS
            });
            return
        }
        setSelectedCustomer({
            isOpen: true,
            customerServicersID: []
        });
    };

    function onFilter(tagsGroup) {
        if (tagSelected === "") return true
        if (tagsGroup === null) return false
        var palavras = tagsGroup?.split(",")?.map(function (palavra) {
            return palavra?.trim();
        });
        return palavras?.includes(tagSelected);
    };
    const myStateElements = useMemo(() => myChatsGroup?.map((group) => {
        const shouldShowCard = onFilter(group.usuario_tags);
        return (
            <ContentGroup
                isVisibility={isVisibility}
                showCard={shouldShowCard}
                key={group.usuario_login}
                currentCustomer={dataCustomer}
                group={group}
                loadChats={handleMyGroup}
                onSelectedCustomer={onSelectedCustomer}
                selectedCustomer={selectedCustomer}
                allowAddInRoom={allowAddInRoom}
            />
        );
    }), [myChatsGroup, dataCustomer, tagSelected, selectedCustomer]);


    return (
        <Container visibility={isVisibility ? 1 : 0}>
            {myChatsGroup?.length !== 0 && (
                <SelectMultipleCustomerService
                    isOpen={selectedCustomer.isOpen}
                    customersSelected={selectedCustomer.customerServicersID}
                    customerServicesAll={allIDS?.length}
                    onClose={() => {
                        setSelectedCustomer({
                            isOpen: false,
                            customerServicersID: []
                        })
                    }}
                    onOpen={() => {
                        setSelectedCustomer({
                            isOpen: true,
                            customerServicersID: []
                        })
                    }}
                    onSelectAll={(e) => {
                        handleSelectedAll(e)
                    }}
                    actions={{
                        initialize: true,
                        transfer: false,
                        finish: true
                    }}
                />
            )}
            <SelectTags>
                <div className='xtr'>
                    <Tabs backgroundColor="#ffffff">
                        <Tab
                            className={`tag-- ${tagSelected === "" && "selected"}`}
                            onClick={() => setTagSelected("")}
                        >
                            <span>
                                Todos
                            </span>
                        </Tab>
                        {myTagsGroup.map((tag) => {
                            return (
                                <Tab
                                    key={tag}
                                    className={`tag-- ${tagSelected === tag && "selected"}`}
                                    onClick={() => setTagSelected(tag)}
                                >
                                    <span>
                                        {tag}
                                    </span>
                                </Tab>
                            )
                        })}
                    </Tabs>
                </div>
            </SelectTags>
            <Content>
                {myStateElements}
            </Content>
        </Container>
    );
}